// import { useEffect } from "react";
// import "./App.css";
// import { Routes, Route } from "react-router-dom";
// import Dashboard from "../src/dashboard/Dashboard";
// import LoginPage from "./Auth/Login";
// import Registration from "./Auth/Registration";
// import ProtectedRoute from "./Auth/Authentication/ProtectedRoute";
// import PublicRoute from "./Auth/Authentication/PublicRoute";
// import { startTokenWatcher, isTokenExpired } from './Services/tokenHelper';

// function App() {
//   useEffect(() => {
//     const token = localStorage.getItem('access');

//     if (token && !isTokenExpired()) {
//       startTokenWatcher();
//     } else if (token && isTokenExpired()) {
//       localStorage.clear();
//     }
//   }, []);

//   return (
//     <Routes>
//       {/* 🔓 Public Routes */}
//       <Route
//         path="/"
//         element={
//           <PublicRoute>
//             <LoginPage />
//           </PublicRoute>
//         }
//       />
//       <Route
//         path="/register"
//         element={
//           <PublicRoute>
//             <Registration />
//           </PublicRoute>
//         }
//       />

//       {/* 🔒 Protected Routes - Direct Dashboard without division page */}
//       <Route
//         path="/dashboard/*"
//         element={
//           <ProtectedRoute>
//             <Dashboard />
//           </ProtectedRoute>
//         }
//       />
//     </Routes>
//   );
// }

// export default App;

















import { useEffect } from "react";
import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Dashboard from "../src/dashboard/Dashboard";
import LoginPage from "./Auth/Login";
import Registration from "./Auth/Registration";
import ProtectedRoute from "./Auth/Authentication/ProtectedRoute";
import PublicRoute from "./Auth/Authentication/PublicRoute";
import { startTokenWatcher, isTokenExpired } from './Services/tokenHelper';
import DivisionPage from "./dashboard/components/Divisions";
import DivisionGuard from "./dashboard/components/DivisionGuard";

function App() {
  useEffect(() => {
    const token = localStorage.getItem('access');

    // Token hai aur valid hai tabhi watcher start karo
    if (token && !isTokenExpired()) {
      startTokenWatcher();
    } else if (token && isTokenExpired()) {
      localStorage.clear();
    }
  }, []);
  return (
    // <BrowserRouter>
    <Routes>
      {/* 🔓 Public Routes */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <Registration />
          </PublicRoute>
        }
      />

      {/* 🔒 Protected Routes */}

       <Route
        path="/division-cards"
        element={
          <ProtectedRoute>
            <DivisionPage/>
          </ProtectedRoute>
        }
      />

       <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <DivisionGuard>
              <Dashboard />
            </DivisionGuard>
          </ProtectedRoute>
        }
      />
    </Routes>
    // </BrowserRouter>
  );
}

export default App;
